import { loader } from 'fetch-tree';
import { getHighlights } from '../actions/markup';
import { selectNotesByContent } from '../selectors/markup';

export const notesByContentLoader = loader({
    id: content => `notes-${content.id}`,
    action(content) {
        return getHighlights(content.id);
    },
    selector: selectNotesByContent,
});



// WEBPACK FOOTER //
// ./src/resources/markup.js